import { ChannelType, channelTypeInfo } from "../../models/ChannelType";
import Device from "../../models/Device";
import { getTemplateGroup } from "../../models/TemplateGroup";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";
import { itx } from "../../translationItx/itx";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  let devicesWithoutTemplate: Array<Device> = getDevicesWithoutAnTemplate();
  let firstDeviceWithoutAnTemplateId: string | undefined;
  function getDevicesWithoutAnTemplate(): Array<Device> {
    const devicesWithoutTemplate = new Array<Device>();
    let devices = state.allDevices();
    if (type == "Actor") {
      devices = state.allActors();
    } else if (type == "Button") {
      devices = new Array<Device>();
      state.allButtons().forEach((buttonOrSensor) => {
        if (buttonOrSensor.isButton) {
          devices.push(buttonOrSensor);
        }
      });
    }
    devices.forEach((dev) => {
      if (dev.template == undefined && !channelTypeInfo(dev.channelType).isSupply) {
        devicesWithoutTemplate.push(dev);
      }
    });

    return devicesWithoutTemplate;
  }

  function chooseTemplate(device: Device): Array<SequenceStep> {
    const res = new Array<SequenceStep>();
    let templateId = "load"; // no itx

    const aktorButtonTemplateGroup = getTemplateGroup(type);

    function getOrderNumber(device: Device): string {
      if (type == "Actor") {
        let on = "AKD-04"; // no itx
        const channeltype = device?.channelType;
        switch (channeltype) {
          case ChannelType.Switch: {
            on = "AKS-12"; // no itx
            break;
          }

          case ChannelType.Blind:
          case ChannelType.Jalousie: {
            on = "JAL-04"; // no itx
            break;
          }
        }
        return on;
      } else {
        return "BE-GT2T"; // no itx
      }
    }

    if (aktorButtonTemplateGroup?.templates.size == 0) {
    } else if (type == "Button") {
      // set here the first template id of button
    } else if (aktorButtonTemplateGroup) {
      /// check which channeltype Actor has and

      aktorButtonTemplateGroup.templates.sortBy("name").forEach((template) => {
        if (template.knxProductData?.productInfo?.OrderNumber?.startsWith(getOrderNumber(device))) {
          templateId = template.id;
        }
      });
    }

    res.push(
      {
        func: async (): Promise<void> => {
          if (devicesWithoutTemplate) {
            state.selectionManager.selectedObject = device;
            firstDeviceWithoutAnTemplateId = device?.id;
          }
        },
        action: enumActions.function,
      },
      { action: enumActions.wait },
      {
        id: () => {
          return `tv-${firstDeviceWithoutAnTemplateId}`;
        },
        action: enumActions.focus,
      },
      {
        id: () => {
          return [`tv-${firstDeviceWithoutAnTemplateId}`, "homePane_openDeviceSettings"]; // no itx
        },
        action: enumActions.click,
      },
      {
        id: () => {
          return `templateSelection-${firstDeviceWithoutAnTemplateId}`;
        },
        text: templateId,
        action: enumActions.select,
      },
    );

    if (templateId == "load") {
      // load new Template from Katalog
      res.push(
        {
          action: enumActions.function,
          func: async (): Promise<void> => {
            console.log("template list waiting ....");
            state.serverTemplatelistLoaded.value = false;
            const val = await state.serverTemplatelistLoaded.waitForChange();
            console.log("template list loaded");
          },
        },

        {
          id: () => {
            return [".filterOrderNumber", "@input"]; // no itx
          },
          action: enumActions.type,
          text: getOrderNumber(device),
        },
        { action: enumActions.wait },
        {
          id: () => {
            //
            // 2. Reihe = 1, Daten-Reihe
            //
            return [`[aria-rowindex="2"]`, `[aria-colindex="3"]`];
          },
          action: enumActions.click,
        },
        {
          id: `BaseDialog_ok`,
          action: enumActions.click,
        },
      );
    } else {
      /// use allready loaded Template
    }

    // templateArray.forEach((template) => {
    //   templateSelectionElmements.push(
    //     <option value={template.id} key={template.id}>
    //       {template.name}
    //     </option>,
    //   );
    // });

    return res;
  }
  return [
    {
      func: async (): Promise<void> => {
        if (devicesWithoutTemplate) {
          state.selectionManager.selectedObject = devicesWithoutTemplate[0];
          firstDeviceWithoutAnTemplateId = devicesWithoutTemplate[0]?.id;
        }
      },
      action: enumActions.function,
    },
    {
      action: enumActions.call,
      subSequence: () => {
        if (devicesWithoutTemplate) {
          let seq = new Array<SequenceStep>();
          let device: Device | undefined;
          if (type == "Actor") {
            devicesWithoutTemplate.forEach((dev) => {
              if (!channelTypeInfo(dev.channelType).isSupply && device == undefined) {
                device = dev;
              }
            });
          } else {
            device = devicesWithoutTemplate[0];
          }
          if (device) {
            seq.push(...chooseTemplate(device));
            return seq;
          } else {
            return [{ action: enumActions.explain, text: itx("quideSequence.noDeviceFound", "kein Device gefunden") }];
          }
        } else {
          return [{ action: enumActions.explain, text: itx("quideSequence.noDeviceFound", "kein Device gefunden") }];
        }
      },
    },
  ];
}

export default sequence;
